import i18next from 'i18next';
import React from 'react';

import { Tooltip } from '@mui/material';

import Text, { ENUM_COLORS } from '@commons/Text';

import { SubNutritionFacts } from './styledComponents';

export const getNutritionFactsColumns = () => [
  {
    field: 'label',
    headerName: '',
    flex: 3,
    editable: false,
    sortable: false,
    renderCell: (params) => (
      <>
        {params.row.isSubNutritionFact ? (
          <SubNutritionFacts>{params.row.label}</SubNutritionFacts>
        ) : (
          params.row.label
        )}

        {params.row.tooltipText && (
          <Tooltip
            placement="top"
            title={<Text color={ENUM_COLORS.LIGHT}>{params.row.tooltipText}</Text>}
            arrow
          >
            <img
              height="14"
              src="/images/icon-tooltip-plain-dark.svg"
              style={{ marginLeft: '8px' }}
              width="14"
            />
          </Tooltip>
        )}
      </>
    ),
  },
  {
    field: 'value',
    headerName: '',
    flex: 1,
    editable: true,
    sortable: false,
  },
];

export const nutritionFactsHeaders = () => [
  {
    label: i18next.t('ADMIN.SUPPLIER_PRODUCTS.ENERGY_LABEL'),
    value: 'energy',
    tooltipText: i18next.t('ADMIN.SUPPLIER_PRODUCTS.ENERGY_TOOLTIP'),
  },
  {
    label: i18next.t('ADMIN.SUPPLIER_PRODUCTS.FAT_LABEL'),
    value: 'fat',
  },
  {
    label: i18next.t('ADMIN.SUPPLIER_PRODUCTS.SATURATED_FAT_LABEL'),
    value: 'saturatedFat',
    isSubNutritionFact: true,
  },
  {
    label: i18next.t('ADMIN.SUPPLIER_PRODUCTS.CARBOHYDRATES_LABEL'),
    value: 'carbohydrates',
  },
  {
    label: i18next.t('ADMIN.SUPPLIER_PRODUCTS.SUGAR_LABEL'),
    value: 'sugar',
    isSubNutritionFact: true,
  },
  {
    label: i18next.t('ADMIN.SUPPLIER_PRODUCTS.FIBER_LABEL'),
    value: 'fiber',
  },
  {
    label: i18next.t('ADMIN.SUPPLIER_PRODUCTS.PROTEIN_LABEL'),
    value: 'protein',
  },
  {
    label: i18next.t('ADMIN.SUPPLIER_PRODUCTS.SALT_LABEL'),
    value: 'salt',
  },
];
